module.exports = __webpack_public_path__ + "static/media/ic_bold.90183230.svg";